<template>
  <div>
    <el-dialog
      title="ĐẠI LÝ TỈNH"
      :visible.sync="this.showFormDaiLyTinh"
      width="70%"
      :close-on-click-modal="false"
      :before-close="handleClose"
      custom-class="form-agents"
    >
      <div class="form-add-agent-list">
        <el-form>
          <el-form-item label="Tên đại lý">
            <el-input
              disabled
              v-model="this.thong_tin_dai_ly.ten_dai_ly"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <label for="">Tỉnh<span style="color: #ff0000"> *</span></label>
            <el-select
              v-model="provinceName"
              :multiple="them_dai_ly_tinh"
              placeholder="Chọn Tỉnh/Thành phố"
              @change="changeIdProvinceSelect"
              :disabled="xem_dai_ly_tinh || cap_nhat_dai_ly_tinh"
            >
              <el-option
                v-for="item in province"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <label for="">Cấp<span style="color: #ff0000"> *</span></label>
            <el-select
              v-model="agt_cap_ten"
              placeholder="Chọn cấp đại lý"
              @change="getChietKhau"
              :disabled="xem_dai_ly_tinh"
            >
              <el-option
                v-for="item in agt_cap"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="chinh_thuc" v-if="!them_dai_ly_tinh"
              >Đại lý tỉnh chính thức</el-checkbox
            >
            <el-checkbox v-model="hieu_luc" v-if="!them_dai_ly_tinh"
              >Đại lý tỉnh được kích hoạt</el-checkbox
            >
            <el-checkbox v-model="chiet_khau_co_dinh"
              >Chiết khấu cố định</el-checkbox
            >
          </el-form-item>
          <div
            class="chiet-khau"
            v-if="chiet_khau.length > 0 && chiet_khau_co_dinh"
          >
            <b-row>
              <b-col md="12" class="chiet-khau-text"
                >Thông tin chiết khấu</b-col
              >
              <b-col md="6" v-for="item in chiet_khau" :key="item.id"
                ><el-form-item>
                  <div class="d-flex justify-content-between">
                    <div class="label-chiet-khau" :title="item.label">{{ item.label }}</div>
                    <div class="d-flex">
                      <el-input-number
                        v-model="item.value"
                        controls-position="right"
                        :min="0"
                        :max="100"
                        v-if="them_dai_ly_tinh || cap_nhat_dai_ly_tinh"
                      ></el-input-number>
                      <el-input-number
                        v-model="item.value"
                        controls-position="right"
                        :min="0"
                        :max="100"
                        v-if="xem_dai_ly_tinh"
                        disabled
                      ></el-input-number>
                      <div class="chiet-khau-goc-group">
                        %
                        <div
                          class="chiet-khau-goc"
                          :class="{ visibility_hidden: !item.gia_tri_theo_cap }"
                          v-if="them_dai_ly_tinh || cap_nhat_dai_ly_tinh"
                        >
                          {{ item.gia_tri_theo_cap }}%
                        </div>
                      </div>
                    </div>
                  </div>
                </el-form-item></b-col
              >
            </b-row>
          </div>
        </el-form>
        <div class="text-center">
          <el-button
            type="primary"
            @click="actionAgentList('create')"
            :disabled="!idProvinceSelect || !id_cap"
            v-if="them_dai_ly_tinh"
            >Thêm mới</el-button
          >
          <el-button
            type="primary"
            @click="isCapNhatChietKhauDaiLyTinh = !isCapNhatChietKhauDaiLyTinh"
            v-if="cap_nhat_dai_ly_tinh"
            >Cập nhật</el-button
          >
        </div>
      </div>
    </el-dialog>
    <Authentication
      v-if="isCapNhatChietKhauDaiLyTinh"
      :action="'update_grant'"
      @update_grant="updateGrantAgent"
      @close_dialog="isCapNhatChietKhauDaiLyTinh = false"
    ></Authentication>
  </div>
</template>
<script>
import mushroom from "viettoc-api";
import MethodService from "@/service/MethodService";
import Authentication from "@/component/Authentication";
import LoginVue from "../../../auth/Login.vue";

export default {
  props: {
    thong_tin_dai_ly: Object,
    them_dai_ly_tinh: Boolean,
    cap_nhat_dai_ly_tinh: Boolean,
    xem_dai_ly_tinh: Boolean,
    dataAgentProvince: Array,
  },
  components: {
    Authentication,
  },
  data() {
    return {
      checked: true,
      province: [], // danh sách tỉnh đã lọc idProvince
      agt_cap: [],
      agt_cap_ten: "",
      provinceName: "",
      listIdProvince: [], // list id Tỉnh của đại lý đã đăng ký
      idProvinceSelect: undefined, // id khi select
      id_cap: undefined, // id cấp đại lý khi select
      chinh_thuc: undefined,
      hieu_luc: undefined,
      chiet_khau: [],
      chiet_khau_co_dinh: false,
      showFormDaiLyTinh: true,
      chiet_khau_goc: [],
      isCapNhatChietKhauDaiLyTinh: false,
    };
  },
  methods: {
    async getAllTinh() {
      this.province = [];
      try {
        const response = await mushroom.province.getAllAsync({
          limit: 100,
        });
        if (response.result && response.result.length > 0) {
          if (this.listIdProvince.length > 0 && this.them_dai_ly_tinh) {
            this.listIdProvince.forEach((x) => {
              response.result.forEach((item, index) => {
                if (item.id == x) response.result.splice(index, 1);
              });
            });
          }
          response.result.forEach((item) => {
            this.province.push({
              value: item.id,
              label: item.type + " " + item.name,
            });
          });
        }
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    async getListIdTinh() {
      try {
        const response = await mushroom.agt_dai_ly_tinh.getAllAsync({
          filters: ["dai_ly_id=" + this.$router.currentRoute.params.id],
          fields: "dai_ly_id,tinh_id",
        });

        if (response.result && response.result.length > 0) {
          this.listIdProvince = response.result.map((item) => item.tinh_id);
        }
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    async getCapDaiLy() {
      this.agt_cap = [];
      try {
        const response = await mushroom.agt_cap.getAllAsync({
          limit: 100,
          filters: ["hieu_luc=true"],
        });
        if (response.result && response.result.length > 0) {
          response.result.forEach((item) => {
            this.agt_cap.push({
              value: item.id,
              label: item.ten,
              chiet_khau: item.chiet_khau,
            });
          });
        }
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    async updateGrantAgent() {
      await this.actionAgentList("update");
    },
    async callAPI(item) {
      try {
        const agt_dai_ly_tinh_object = {
          dai_ly_id: this.$router.currentRoute.params.id,
          tinh_id: item,
          cap_id: this.id_cap,
          chinh_thuc: this.chinh_thuc,
          hieu_luc: this.hieu_luc,
          chiet_khau_co_dinh: this.chiet_khau_co_dinh,
          chiet_khau: this.chiet_khau_co_dinh
            ? this.changeChietKhau(this.chiet_khau)
            : null,
        };
        await mushroom.agt_dai_ly_tinh.createAsync(agt_dai_ly_tinh_object);
      } catch (error) {
        console.error(`Lỗi thêm mới đại lý tỉnh ${item}: ${error}`);
      }
    },
    async actionAgentList(type) {
      const agt_dai_ly_tinh_object = {
        dai_ly_id: this.$router.currentRoute.params.id,
        tinh_id: this.idProvinceSelect,
        cap_id: this.id_cap,
        chinh_thuc: this.chinh_thuc,
        hieu_luc: this.hieu_luc,
        chiet_khau_co_dinh: this.chiet_khau_co_dinh,
        chiet_khau: this.chiet_khau_co_dinh
          ? this.changeChietKhau(this.chiet_khau)
          : null,
      };
      console.log("agt_dai_ly_tinh_object", agt_dai_ly_tinh_object);
      try {
        if (type == "create") {
          await Promise.all(
            this.provinceName.map((item) => this.callAPI(item))
          );
          window.toastr.success("Thêm mới đại lý tỉnh thành công");
          this.$emit("reload-list-dai-ly-tinh");
          // agt_dai_ly_tinh_object.chinh_thuc = true;
          // agt_dai_ly_tinh_object.hieu_luc = true;
          // const newId = await mushroom.agt_dai_ly_tinh.createAsync(
          //   agt_dai_ly_tinh_object
          // );
          // if (newId) {
          //   window.toastr.success("Thêm mới đại lý tỉnh thành công");
          //   this.$emit("reload-list-dai-ly-tinh");
          // }
        } else {
          delete agt_dai_ly_tinh_object["tinh_id"];
          delete agt_dai_ly_tinh_object["dai_ly_id"];
          agt_dai_ly_tinh_object.id = this.dataAgentProvince[0].id;
          const response = await mushroom.agt_dai_ly_tinh.partialUpdateAsync(
            agt_dai_ly_tinh_object
          );
          if (response.result == this.dataAgentProvince[0].id) {
            window.toastr.success("Cập nhật đại lý tỉnh thành công");
            this.$emit("reload-list-dai-ly-tinh");
          } else window.toastr.warning("Dữ liệu không thay đổi");
        }
      } catch (e) {
        console.error("Có lỗi: %o", e);
        MethodService.showError(e.code);
      } finally {
        this.$emit("close-dialog-form-agent-list");
      }
    },
    async getTenSanPhamChietKhau(id) {
      try {
        const response = await mushroom.prd_san_pham.findByIdAsync({
          id: id,
          fields: "ten, ma_sp",
        });
        if (response.result)
          return response.result.ma_sp + "-" + response.result.ten;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    async getChietKhau(id_cap) {
      this.chiet_khau = [];
      let arr = [];
      const response = await mushroom.prd_san_pham.getAllAsync({
        filters: ["dai_ly_ban=true", "hieu_luc=true"],
        limit: 100,
      });
      response.result.forEach((item) => {
        if (id_cap) {
          this.id_cap = id_cap;
          arr = this.agt_cap.filter((x) => x.value == id_cap);
          arr[0].chiet_khau.forEach((x) => {
            if (x.san_pham_id == item.id) item.gia_tri_theo_cap = x.gia_tri;
          });
        }
        if (!this.them_dai_ly_tinh) {
          if (
            this.dataAgentProvince[0].chiet_khau &&
            this.dataAgentProvince[0].chiet_khau.length > 0
          ) {
            this.dataAgentProvince[0].chiet_khau.forEach((x) => {
              if (item.id === x.san_pham_id)
                item.gia_tri_db = x.gia_tri !== null ? x.gia_tri : undefined;
            });
          }
        }

        this.chiet_khau.push({
          value: item.gia_tri_db,
          gia_tri: item.gia_tri,
          label: item.ma_sp + "-" + item.ten,
          san_pham_id: item.id,
          gia_tri_theo_cap: item.gia_tri_theo_cap, // giá trị chiết khấu theo cấp, không nhập thì lấy giá trị này
        });
      });
      // console.log(
      //   "this.dataAgentProvince[0].chiet_khau",
      //   this.dataAgentProvince[0].chiet_khau
      // );
      // console.log(" this.chiet_khau", this.chiet_khau);
    },
    changeIdProvinceSelect(id) {
      this.idProvinceSelect = id;
    },
    changeChietKhau(data) {
      let arr = [];
      data.forEach((item) => {
        if (item.value === undefined) {
          arr.push({
            san_pham_id: item.san_pham_id,
            gia_tri: item.gia_tri_theo_cap
              ? Number(item.gia_tri_theo_cap)
              : null,
          });
        } else
          arr.push({
            san_pham_id: item.san_pham_id,
            gia_tri: Number(item.value),
          });
      });
      return arr;
    },
    resetForm() {
      this.idProvinceSelect = undefined;
      this.id_cap = undefined;
      this.chinh_thuc = undefined;
      this.hieu_luc = undefined;
      this.chiet_khau = [];
      this.provinceName = "";
      this.agt_cap_ten = "";
    },
    handleClose() {
      this.$emit("close-dialog-form-agent-list");
      this.resetForm();
    },
    async getChietKhauTheoCap(id) {
      try {
        const response = await mushroom.agt_cap.findByIdAsync({
          id: id,
        });
        this.chiet_khau_goc = response.result.chiet_khau;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    async watchDataAgentProvince() {
      if (this.dataAgentProvince.length > 0) {
        this.chiet_khau_co_dinh = this.dataAgentProvince[0].chiet_khau_co_dinh;
        this.provinceName = this.dataAgentProvince[0].tinh_id;
        this.agt_cap_ten = this.dataAgentProvince[0].cap_id;
        this.chinh_thuc = this.dataAgentProvince[0].chinh_thuc;
        this.hieu_luc = this.dataAgentProvince[0].hieu_luc;
        await this.getCapDaiLy();
        await this.getChietKhau(this.dataAgentProvince[0].cap_id);
      }
    },
  },

  async created() {
    await this.getCapDaiLy();
    if (this.them_dai_ly_tinh) {
      await this.getChietKhau();
    } else if (this.cap_nhat_dai_ly_tinh || this.xem_dai_ly_tinh)
      await this.watchDataAgentProvince();
    await this.getListIdTinh();
    await this.getAllTinh();
  },
};
</script>
<style scoped>
.upload {
  text-align: center;
}
.upload label {
  background-color: #409eff;
  padding: 5px 10px;
  border-radius: 3px;
  color: #fff;
  cursor: pointer;
}
.upload i {
  margin-right: 5px;
}
#upload-hd {
  display: none;
}
.alert-upload {
  color: #67c23a;
  margin: 10px 0 0;
}
::v-deep .chiet-khau .el-input-number {
  width: 120px !important;
  margin-right: 5px;
}
::v-deep .chiet-khau .el-input-number__increase,
::v-deep .chiet-khau .el-input-number__decrease {
  display: none;
}
::v-deep .chiet-khau .el-input-number.is-controls-right .el-input__inner {
  padding-right: 15px;
}
.chiet-khau {
  border: thin dashed #dcdcdc;
  padding: 5px 10px;
  border-radius: 3px;
  margin-bottom: 10px;
}
.chiet-khau-text {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 10px;
}
.chiet-khau-goc-group {
  display: flex;
  align-items: center;
}
.chiet-khau-goc {
  margin-left: 5px;
  background-color: #f4f4f5;
  padding: 0 5px;
  border-radius: 5px;
  color: #909399;
  border: thin solid #d3d4d6;
  min-width: 42px;
  line-height: 23px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.visibility_hidden {
  visibility: hidden;
}
.label-chiet-khau {
  display: block;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* số dòng hiển thị */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 10px;
}
::v-deep .form-agents {
  max-height: calc(90vh - 80px);
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 10vh !important;
}
</style>
